import { render, staticRenderFns } from "./StringData.vue?vue&type=template&id=dbf1b516&scoped=true&"
import script from "./StringData.vue?vue&type=script&lang=js&"
export * from "./StringData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf1b516",
  null
  
)

export default component.exports